/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Edit_LabelInputs */

const en_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit key`)
};

const fr_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la clé`)
};

const de_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten Sie den Schlüssel`)
};

const it_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica chiave`)
};

const ru_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать ключ`)
};

const es_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecla de edición`)
};

const zh_cn2_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑键`)
};

const ja_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集キー`)
};

const hi_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन कुंजी`)
};

const pt_pt2_options_api_keys_edit_label = /** @type {(inputs: Options_Api_Keys_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecla de edição`)
};

/**
* | output |
* | --- |
* | "Edit key" |
*
* @param {Options_Api_Keys_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_edit_label = /** @type {((inputs?: Options_Api_Keys_Edit_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Edit_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_edit_label(inputs)
	if (locale === "de") return de_options_api_keys_edit_label(inputs)
	if (locale === "it") return it_options_api_keys_edit_label(inputs)
	if (locale === "ru") return ru_options_api_keys_edit_label(inputs)
	if (locale === "es") return es_options_api_keys_edit_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_edit_label(inputs)
	if (locale === "ja") return ja_options_api_keys_edit_label(inputs)
	if (locale === "hi") return hi_options_api_keys_edit_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_edit_label(inputs)
	return en_options_api_keys_edit_label(inputs)
});